module.exports = {"create":"Create Partner Manager","createDescription":"Create a Partner Manager-user","success":"Partner Manager created successfully!"};